import React from 'react';
import { BillingEntryState, getPaymentState } from '../../../utils/trip-invoice-utils';
import { TripBilling } from '../../details-view/payments-data/types';
import { TripInvoiceData } from './data/TripInvoiceData';

function renderInvoiceTypeAndPaymentStatus(type, status) {
    switch (type) {
        case 'CHARGE':
            return `Trip (${status})`
        case 'FEE':
            return `Fee (${status})`
        case 'REFUND':
            return `Refund (${status})`
        case 'PRE_PAYMENT':
            return `Prepayment (${status})`
    }
}

export function renderBillingInvoicesList(trip: TripInvoiceData) {
    const billings = trip?.billings || [];
    const tripState = trip?.state || 'COMPLETED';
    const serviceProviderId = trip.serviceProviderId;

    const billingMap = billings.reduce((map, billing) => {
        if (!map[billing.invoiceNumber]) {
            map[billing.invoiceNumber] = [billing];
        } else {
            map[billing.invoiceNumber].push(billing);
        }

        return map;
    }, {} as { [invoiceNumber: string]: TripBilling[] })

    const invoiceNumbers = Object.keys(billingMap);

    return (
        <ul className='row-ul'>
            {
                invoiceNumbers.map(invoiceNumber => {
                    const billings = billingMap[invoiceNumber];

                    const tripItem = billings.find(item => item.type === 'CHARGE') ? [billings.find(item => item.type === 'CHARGE')] : [];
                    const feeItems = billings.filter(item => item.type === 'FEE');

                    const bookingItem = billings.find(item => item.type === 'PRE_PAYMENT') ? [billings.find(item => item.type === 'PRE_PAYMENT')] : [];

                    const chargePaymentStatus = getPaymentState(tripState, tripItem, serviceProviderId, trip.isTotalChargePaid);
                    const feePaymentStatus = getPaymentState(tripState, feeItems, serviceProviderId, trip.isTotalFeePaid);
                    const prePaymentStatus = BillingEntryState[trip.paymentState];

                    return <>
                        {tripItem.map(item =>
                            <li key={item.invoiceNumber + '_li'} className='row-li'>
                                <span key={item.invoiceNumber + '_span'} className='row-li-inline'>
                                    {renderInvoiceTypeAndPaymentStatus(item?.type, chargePaymentStatus)}
                                </span>
                            </li>
                        )}

                        {feeItems?.map(item =>
                            <li key={item.invoiceNumber + '_li'} className='row-li'>
                                <span key={item.invoiceNumber + '_span'} className='row-li-inline'>
                                    {renderInvoiceTypeAndPaymentStatus(item?.type, feePaymentStatus)}
                                </span>
                            </li >
                        )}

                        {bookingItem?.map(item => {
                            return (<li key={item.invoiceNumber + '_li'} className='row-li'>
                                <span key={item.invoiceNumber + '_span'} className='row-li-inline'>
                                    {item?.state ?
                                        renderInvoiceTypeAndPaymentStatus(item?.type, prePaymentStatus) :
                                        'Payment (On Arrival)'
                                    }
                                </span>
                            </li>)
                        })
                        }
                    </>
                })
            }
        </ul >
    )
}

export function renderBillingInvoices(trip: TripInvoiceData, handleOnModalShow: (items: TripBilling[]) => void) {
    const billings = trip?.billings || [];
    const tripState = trip?.state || 'COMPLETED';
    const serviceProviderId = trip.serviceProviderId;

    const billingMap = billings.reduce((map, billing) => {
        if (!map[billing.invoiceNumber]) {
            map[billing.invoiceNumber] = [billing];
        } else {
            map[billing.invoiceNumber].push(billing);
        }

        return map;
    }, {} as { [invoiceNumber: string]: TripBilling[] })

    const invoiceNumbers = Object.keys(billingMap);

    return (
        <ul className='row-ul'>
            {
                invoiceNumbers.map(invoiceNumber => {
                    const billings = billingMap[invoiceNumber];

                    const tripItem = billings.find(item => item.type === 'CHARGE') ? [billings.find(item => item.type === 'CHARGE')] : [];
                    const feeItems = billings.filter(item => item.type === 'FEE');

                    const bookingItem = billings.find(item => item.type === 'PRE_PAYMENT') ? [billings.find(item => item.type === 'PRE_PAYMENT')] : [];

                    const chargePaymentStatus = getPaymentState(tripState, tripItem, serviceProviderId, trip.isTotalChargePaid);
                    const feePaymentStatus = getPaymentState(tripState, feeItems, serviceProviderId, trip.isTotalFeePaid);
                    const prePaymentStatus = BillingEntryState[trip.paymentState];

                    return <>
                        {tripItem.map(item =>
                            <li key={item.invoiceNumber + '_li'} className='row-li'>
                                <span key={item.invoiceNumber + '_span'} className='row-li-inline'>
                                    <a onClick={() => handleOnModalShow(billings)}>
                                        {renderInvoiceTypeAndPaymentStatus(item?.type, chargePaymentStatus)}
                                    </a>
                                </span>
                            </li>
                        )}

                        {feeItems?.map(item =>
                            <li key={item.invoiceNumber + '_li'} className='row-li'>
                                <span key={item.invoiceNumber + '_span'} className='row-li-inline'>
                                    <a onClick={() => handleOnModalShow(billings)}>
                                        {renderInvoiceTypeAndPaymentStatus(item?.type, feePaymentStatus)}
                                    </a>
                                </span>
                            </li>
                        )}

                        {bookingItem?.map(item => {
                            return (<li key={item.invoiceNumber + '_li'} className='row-li'>
                                <span key={item.invoiceNumber + '_span'} className='row-li-inline'>
                                    <a onClick={() => handleOnModalShow(billings)}>
                                        {item?.state ?
                                            renderInvoiceTypeAndPaymentStatus(item?.type, prePaymentStatus) :
                                            'Payment (On Arrival)'
                                        }
                                    </a>
                                </span>
                            </li>)
                        })
                        }
                    </>
                })
            }
        </ul >
    )
}